export const modes = {
	crypto: {
		name: 'Kриптовалута',
		namePl: 'Криптовалути',
		switchBtnLink: '/',
		switchBtnLabel: 'Валутни курсове',
		color: 'cornflower',
		oppositeColor: 'ebony'
	},
	monetary: {
		name: 'Валутен курс',
		namePl: 'Валутни курсове',
		switchBtnLink: '/cryptocurrencies',
		switchBtnLabel: 'Криптовалути',
		color: 'ebony',
		oppositeColor: 'cornflower'
	}
}